import { BounceRate } from "./segments/bounce-rate";
import { MonthlyVisits } from "./segments/monthly-visits";
import { PagePerVisit } from "./segments/page-per-visit";
import { PageViews } from "./segments/page-views";
import { TrafficShare } from "./segments/traffic-share";
import { UniqueVisitors } from "./segments/unique-visitors";
import { VisitDuration } from "./segments/visit-duration";
import { Geography } from "./segments/geography";
import { MonthlyGroupVisits } from "./segments/comparison/monthly-group-visits";
import { TrafficShareGroup } from "./segments/comparison/traffic-group-share";
import { PageViewsGroup } from "./segments/comparison/page-views-group";
import { PagePerVisitGroup } from "./segments/comparison/page-per-visit-group";
import { VisitDurationGroup } from "./segments/comparison/visit-duration-group";
import { BounceRateGroup } from "./segments/comparison/bounce-rate-group";
import { UniqueVisitorsGroup } from "./segments/comparison//unique-visitors-group";

export const SegmentsMonthlyVisits = MonthlyVisits;
export const SegmentsUniqueVisitors = UniqueVisitors;
export const SegmentsPageViews = PageViews;
export const SegmentsPagePerVisit = PagePerVisit;
export const SegmentsVisitDuration = VisitDuration;
export const SegmentsBounceRate = BounceRate;
export const SegmentsTrafficShare = TrafficShare;
export const SegmentsGeography = Geography;
export const SegmentsGroupMonthlyVisits = MonthlyGroupVisits;
export const SegmentsGroupTrafficShare = TrafficShareGroup;
export const SegmentsPageViewsGroup = PageViewsGroup;
export const SegmentsPagePerVisitGroup = PagePerVisitGroup;
export const SegmentsVisitDurationGroup = VisitDurationGroup;
export const SegmentsBounceRateGroup = BounceRateGroup;
export const SegmentsUniqueVisitorsGroup = UniqueVisitorsGroup;
